/**
 * BlogPage Component
 *
 * Placeholder blog landing page until blog content is published.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { SupportLayout } from '../Support/SupportLayout';

export const BlogPage: React.FC = () => (
  <SupportLayout
    title="DARAK Blog"
    subtitle="Travel guides, hosting tips, and stories from across Lebanon."
  >
    <p>
      We're writing our first posts: guides to Lebanon's best destinations,
      tips for hosts, and stories from our community.
    </p>
    <p>
      In the meantime,{' '}
      <Link to="/search" className="text-primary-700 hover:underline">
        browse properties
      </Link>{' '}
      or learn{' '}
      <Link to="/become-host" className="text-primary-700 hover:underline">
        how to become a host
      </Link>
      .
    </p>
  </SupportLayout>
);

export default BlogPage;
